import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: 'transparent',
    opacity: 0.8,
  },
}));

export const ModalContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  '& h1': {
    fontSize: '1.5rem',
    marginBottom: theme.spacing(2),
  },
  '& p': {
    marginBottom: theme.spacing(2),
  },
  '& ul': {
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
})); 